import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemContext } from '../components/ProblemContext';
import { Mechanism } from '../components/Mechanism';
import { WhatYouGet } from '../components/WhatYouGet';
import { Audience } from '../components/Audience';
import { HowItWorks } from '../components/HowItWorks';
import { ProofFAQ } from '../components/ProofFAQ';
import { Offer } from '../components/Offer';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-brand-cream selection:bg-brand-terracotta selection:text-white" data-id="element-178">
      <main data-id="element-179">
        <Hero data-id="element-180" />
        <ProblemContext data-id="element-181" />
        <Mechanism data-id="element-182" />
        <WhatYouGet data-id="element-183" />
        <Audience data-id="element-184" />
        <HowItWorks data-id="element-185" />
        <ProofFAQ data-id="element-186" />
        <Offer data-id="element-187" />
      </main>
      <Footer data-id="element-188" />
    </div>;
}